import React from 'react';
import { ThemeConsumer } from 'styled-components';

const Art: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <ThemeConsumer>
      {(theme) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="122"
          height="94"
          fill="none"
          viewBox="0 0 122 94"
        >
          <path
            fill={theme.primary[50]}
            d="M74.622 0H47.467C30.088 0 16 14.07 16 31.424V62.12c0 17.355 14.088 31.424 31.467 31.424h27.155c17.379 0 31.467-14.069 31.467-31.424V31.425C106.089 14.068 92.001 0 74.622 0z"
          ></path>
          <path
            stroke={theme.primary[100]}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M1 80.769h120"
          ></path>
          <path
            fill={theme.primary[500]}
            d="M45.671 72.258h-2.09c-.523 0-.871.348-.871.87 0 .523.348.872.87.872h2.091c.523 0 .871-.349.871-.871a.873.873 0 00-.871-.871z"
          ></path>
          <path
            fill={theme.primary[500]}
            d="M87.129 37.42H77.026L63.352 23.744c.174-.348.26-.697.26-1.132 0-.523-.348-.871-.87-.871-.523 0-.871.348-.871.87 0 .524-.348.872-.871.872s-.871-.349-.871-.871c0-.523.348-.871.871-.871s.871-.349.871-.871c0-.523-.348-.871-.871-.871-1.48 0-2.613 1.132-2.613 2.613 0 .435.087.784.261 1.132l-8.622 8.623a.842.842 0 000 1.22c.174.173.784.435 1.22 0l8.622-8.623c.348.174 1.22.435 2.264 0l12.455 12.454H47.413l1.045-1.045a.842.842 0 000-1.22.842.842 0 00-1.22 0l-2.264 2.265H34.871c-.871 0-.871.784-.871.871v5.4c0 .523.348.871.871.871s.87-.348.87-.87v-3.31l1.743 1.742v27.174l-1.742 1.742V47c0-.523-.348-.871-.871-.871S34 46.477 34 47v26.129c0 .871.784.871.871.871h5.313c.523 0 .87-.348.87-.871s-.348-.87-.87-.87H36.96l1.742-1.743h44.594l1.742 1.742H48.806c-.522 0-.87.349-.87.871 0 .523.348.871.87.871H87.13c.871 0 .871-.784.871-.871V38.29c0-.697-.784-.87-.871-.87zm-6.968 3.483c-.522 0-.87.349-.87.871 0 .523.348.871.87.871h2.613v17.942L72.061 49.874c-.261-.261-.784-.348-1.132-.087L48.284 65.465c-.436.26-.436.783-.261 1.219.348.523 1.045.348 1.219.261l22.035-15.242 11.497 11.323v5.748H39.226v-5.661l9.58-6.358 3.571 2.7c.349.261.959.174 1.22-.174.261-.349.174-.958-.174-1.22l-4.094-3.048c-.261-.261-.697-.261-1.045 0l-9.058 6.01V42.645h37.451c.523 0 .871-.348.871-.87 0-.523-.348-.872-.87-.872H38.702l-1.742-1.742H85.04l-1.742 1.742H80.16zm6.097 30.136l-1.742-1.742V42.123l1.742-1.742v30.658z"
          ></path>
          <path
            fill={theme.primary[500]}
            d="M55.774 44.387c-.522 0-.87.349-.87.871 0 .523.348.871.87.871 1.48 0 2.613 1.132 2.613 2.613 0 1.48-1.132 2.613-2.613 2.613-1.48 0-2.613-1.132-2.613-2.613 0-.435.087-.958.349-1.393.261-.436.087-.959-.261-1.22-.436-.261-.959-.087-1.22.261-.348.784-.61 1.568-.61 2.352a4.313 4.313 0 004.355 4.355 4.313 4.313 0 004.355-4.355 4.312 4.312 0 00-4.355-4.355zM43.58 44.387H41.84c-.523 0-.871.349-.871.871V47c0 .523.348.871.87.871.523 0 .872-.348.872-.87v-.872h.87c.523 0 .872-.348.872-.87 0-.523-.349-.872-.871-.872zM79.552 65.03a.9.9 0 001.219 0 .842.842 0 000-1.22l-1.742-1.742a.842.842 0 00-1.22 0 .842.842 0 000 1.22l1.743 1.741zM74.326 59.803c.174.175.784.523 1.22 0a.842.842 0 000-1.219L72.06 55.1a.842.842 0 00-1.22 0 .842.842 0 000 1.22l3.485 3.483z"
          ></path>
          <rect
            width="2"
            height="8"
            x="96"
            y="45"
            fill={theme.primary[500]}
            rx="1"
          ></rect>
          <rect
            width="2"
            height="8"
            x="93"
            y="50"
            fill={theme.primary[500]}
            rx="1"
            transform="rotate(-90 93 50)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="27.639"
            y="57.81"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(45 27.639 57.81)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="22.811"
            y="59.018"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(-45 22.81 59.018)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="70.639"
            y="10.81"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(45 70.639 10.81)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="65.811"
            y="12.018"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(-45 65.81 12.018)"
          ></rect>
          <circle
            cx="73.5"
            cy="83.5"
            r="2.5"
            fill={theme.primary[500]}
          ></circle>
          <circle cx="38" cy="24" r="2" fill={theme.primary[500]}></circle>
          <circle
            cx="94.5"
            cy="28.5"
            r="1.5"
            fill={theme.primary[500]}
          ></circle>
        </svg>
      )}
    </ThemeConsumer>
  );
};

export default Art;
